export default __webpack_public_path__ + "static/media/_payment-failed-card.89bbb36d.svg";